import cx from 'classnames'
import * as React from 'react'

import Spacer, { SpacerProps } from '../spacer'
import styles from './form-field-group.module.scss'

export type Props = {
  children: string | React.ReactNode
  className?: string
} & SpacerProps

export default function FormFieldGroup(props: Props) {
  const { children, className, ...otherProps } = props

  return (
    <Spacer {...otherProps} className={cx(styles.root, className)}>
      {children}
    </Spacer>
  )
}
